import React, { useState, useEffect } from "react";
import localization from "assets/localization/localization";
import ConstantInput from "../Input/constantInput/constantInput";

const CasesFilterUcd = ({ applyFilter }) => {
  const parseLocalStorage = () => {
    try {
      const data = JSON.parse(window.localStorage?.filterData || "{}");
      return {
        loan_id: data.loan_id || "",
        vehicle_number: data.vehicle_number || ""
      };
    } catch {
      return {
        loan_id: "",
        vehicle_number: ""
      };
    }
  };

  const initialFilterInputs = parseLocalStorage();

  const [filterFieldsData, setFilterFieldsData] = useState({
    loan_id: initialFilterInputs.loan_id,
    vehicle_number: initialFilterInputs.vehicle_number
  });


  useEffect(() => {
    const storedData = parseLocalStorage();
    setFilterFieldsData({
        loan_id: storedData.loan_id ? storedData.loan_id : "",
        vehicle_number: storedData.vehicle_number? storedData.vehicle_number : ""
    });
  }, []);

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        applyFilter({
            loan_id: filterFieldsData.loan_id ? filterFieldsData.loan_id : "",
            vehicle_number: filterFieldsData.vehicle_number ? filterFieldsData.vehicle_number : ""
        });
      }}
    >
      <ConstantInput
        label={"Unique ID"}
        value={window.localStorage?.all_valet_list_filter && window.localStorage?.filterData ? JSON.parse(window.localStorage?.filterData)['loan_id'] : ""}
        type="text"
        handleChange={(val) => {
          setFilterFieldsData({ ...filterFieldsData, loan_id: val });
        }}
      />
      <ConstantInput
        label={"Vehicle No."}
        value={window.localStorage?.filterData && window.localStorage?.filterData ? JSON.parse(window.localStorage?.filterData)['vehicle_number'] : ""}
        type="text"
        handleChange={(val) => {
          setFilterFieldsData({ ...filterFieldsData, vehicle_number: val });
        }}
      />
      <br />
      <br />
      <br />
      <div className="btn-wrapper">
        <button disabled={false} type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src="../images/arrow-right.png" alt="" />
        </button>
        <br />
        <br />
        <button
          onClick={() => {
            setFilterFieldsData(initialFilterInputs);
            applyFilter({
              business_name: ""
            });
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

export default CasesFilterUcd;
